export type TeamInvitationStatus = 'pending' | 'accepted' | 'declined' | 'cancelled';

export interface TeamInvitation {
  id: string;
  teamId: string;
  teamName: string;
  inviterId: string;
  inviteeId: string;
  inviteeName?: string;
  inviteeEmail?: string;
  status: TeamInvitationStatus;
  message?: string;
  createdAt: Date;
}
